var _style, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _circle2, _path8, _path9, _path10, _path11, _path12, _polygon, _polygon2, _path13, _polygon3, _path14, _path15, _circle3, _rect, _path16, _path17, _g, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationAlerts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850 550",
    style: {
      enableBackground: "new 0 0 850 550"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6E6E6;}\n\t.st1{fill:#CACACA;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#E4E4E4;}\n\t.st4{fill:#3F3D56;}\n\t.st5{fill:#FFB6B6;}\n\t.st6{fill:url(#SVGID_1_);}\n\t.st7{fill:#2F2E41;}\n\t.st8{opacity:0.2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a08a2523-9d19-4e0c-87cb-6ce1a7fd2fc4-44",
    className: "st0",
    d: "M71.9,466c7.2,11.5,16.1,21.9,26.2,31c0.3,0.2,0.5,0.5,0.7,0.6 l21.6-12.9c-0.2-0.2-0.4-0.5-0.5-0.7c-11.2-15.8-62.4-120.6-62.7-143.8C57.2,342,38.8,414.2,71.9,466z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a62b1d0a-4504-46a8-81c8-bbc6043ad63f-45",
    className: "st0",
    d: "M94,499.4c0.4,0.2,0.6,0.3,1,0.5l16.3-9.7 c-0.3-0.2-0.5-0.4-0.9-0.5c-5.6-3.3-22.1-13.1-38.4-23.7c-17.5-11.4-34.8-23.8-37.7-30.3C34.7,437.1,54.1,482.1,94,499.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "fd401fbc-93ba-42a5-a9a4-5a6900171ed6-46",
    className: "st0",
    d: "M781,508.3c-0.4,13.6-2.6,27-6.8,40c-0.1,0.3-0.2,0.6-0.3,0.9 h-25.2c0-0.3,0.1-0.5,0.1-0.9c1.6-19.4-7.9-135.6-19.5-155.7C730.4,394.2,783,446.8,781,508.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "eaa08601-a63b-4214-86e2-4a8f8e2c7e12-47",
    className: "st0",
    d: "M779.1,548.3c-0.2,0.3-0.5,0.6-0.6,0.9h-18.9 c0.2-0.3,0.3-0.5,0.5-0.9c3.1-5.7,12.4-22.5,21-40c9.2-18.8,17.7-38.3,17-45.4C798.2,464.5,804.6,513,779.1,548.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.2,548.4H117.5c-14.4,0-26-11.7-26-26v-423c0-14.3,11.7-26,26-26h291.6c14.4,0,26,11.7,26,26v422.9 C435.3,536.8,423.6,548.4,409.2,548.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M409.7,531.8H117.1c-4.5,0-8-3.6-8-8V98c0-4.5,3.6-8,8-8h292.7c4.5,0,8,3.6,8,8v425.8 C417.7,528.2,414.2,531.8,409.7,531.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 262.3,
    cy: 81.3,
    r: 2.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M848.9,550H1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1l0,0h847.8c0.6,0,1.1,0.5,1.1,1.1 C850,549.5,849.5,550,848.9,550L848.9,550z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 263.4,
    cy: 397.8,
    r: 28.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M281.1,343.5h-35.4l-21.4-104.7c-2.2-21.6,13.6-40.9,35.2-43.1c21.6-2.2,40.9,13.6,43.1,35.2 c0.3,2.6,0.3,5.2,0,7.9L281.1,343.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M402.7,202.9h129.6c12.9,0,24,9,26.9,21.5l65.5,290.4c2.7,12-4.8,23.9-16.8,26.6c-1.3,0.3-2.6,0.5-3.8,0.5 l-133.2,6.6c-14.8,0.7-27.8-9.6-30.4-24.1L403.2,319l-7-38.8l-10.4-57.4c-1.6-9.2,4.5-18.1,13.7-19.7 C400.6,202.9,401.7,202.9,402.7,202.9L402.7,202.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M515.2,209.1h15.2c9,0,16.7,6.2,18.6,15l62.8,288.1c1.4,6.4-2.6,12.7-9,14.1c-0.5,0.1-1.2,0.2-1.7,0.3 l-132.8,8.7c-7.8,0.5-14.6-4.9-16.1-12.5l-53.6-297.7c-1.3-7.3,3.6-14.2,10.8-15.5c0.8-0.2,1.6-0.2,2.4-0.2h14.3 c2.8,0,5.4,1.9,6.1,4.7l0,0c0.6,2.5,2.8,4.1,5.4,4.1h68.1C510.7,217.9,514.8,214.1,515.2,209.1L515.2,209.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M582.2,301.4c0.5,0.3,0.8,0.5,1.2,0.9l43.9-11.2l3-10.6l16.5,2.5l-3.5,19.3c-0.5,3.2-3.2,5.7-6.4,5.9l-51.2,5.4 c-2.3,4.7-7.9,6.8-12.8,4.6c-4.7-2.3-6.8-7.9-4.6-12.8c2.3-4.7,7.9-6.8,12.8-4.6C581.5,301,581.9,301.2,582.2,301.4L582.2,301.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 490.2105,
    y1: 3877.7512,
    x2: 587.2857,
    y2: 3909.3809,
    gradientTransform: "matrix(1 0 0 1 0 -3671.9995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M550.9,284.5c15.6,0,28.3,12.7,28.3,28.3c0,15.6-12.7,28.3-28.3,28.3s-28.3-12.7-28.3-28.3 S535.3,284.5,550.9,284.5z M568.6,258.5h-35.4l-21.4-104.7c-2.2-21.6,13.6-40.9,35.2-43.1c21.6-2.2,40.9,13.6,43.1,35.2 c0.3,2.6,0.3,5.2,0,7.9L568.6,258.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "649.8,292.6 638.5,302.3 622.7,316 615.7,280.2 615,276.6 614.4,273.5 630.4,245.7 643.8,246.4  644.7,246.5 644.7,246.7 645,248.5 647.7,273.2 647.7,273.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "575.9,537 564.7,537 559.4,493.8 575.9,493.8 "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M578.8,547.9h-36.1v-0.5c0-7.8,6.3-14.1,14.1-14.1l0,0h22V547.9z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "692.8,537.9 681.6,537.9 676.3,494.7 692.8,494.7 "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M695.7,548.8h-36.1v-0.5c0-7.8,6.3-14.1,14.1-14.1l0,0h22V548.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M701.8,518.9l-30.1,4.6l-43.8-148.4l-46.6,149.3l-33.8-4.6l43.8-173.5v-13.7l5.9-20.5l-0.6-5.6l-4.3-38.9 l-1.8-16.9l-0.1-1.1c-0.2-1.9,1.1-3.7,2.9-4l0,0l14.1-2.9h23l13.6,3.7l0.9,0.3l0.5,0.1l-0.2,1.7l-3.2,26.7l-0.2,1.5l-3.1,25.7 L638,308c26.5,19.2,27.4,38.4,27.4,38.4L701.8,518.9z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 615.9,
    cy: 208.7,
    r: 22.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 595.4,
    y: 305.7,
    transform: "matrix(0.9916 -0.1297 0.1297 0.9916 -34.845 82.7315)",
    className: "st4",
    width: 44.8,
    height: 6.4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M535.6,310.5c0.5,0.3,0.8,0.5,1.2,0.9l43.9-11.2l3-10.6l16.5,2.5l-3.5,19.3c-0.5,3.2-3.2,5.7-6.4,5.9l-51.2,5.4 c-2.3,4.7-7.9,6.8-12.8,4.6c-4.7-2.3-6.8-7.9-4.6-12.8c2.3-4.7,7.9-6.8,12.8-4.6C534.9,310.2,535.3,310.4,535.6,310.5L535.6,310.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M603.1,251.4l-7.8-5.9c-2.1-0.8-4.9,1.5-5.5,3.7l-11,44.8l22.8,16.4l3.2-5L603.1,251.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M647.7,273.2c-1.9,0.7-3.9,1.5-5.9,2c-0.6,0.2-1.3,0.4-1.9,0.5c-4.3,1.2-8.7,1.9-13.1,2.1c-1.9,0.1-3.8,0-5.8-0.2 c-2-0.2-4-0.6-6-1.2c-0.1,0-0.2,0-0.2-0.1c-4.1-1.2-7.9-3.3-11-6.2c-0.7-0.6-1.4-1.4-1.9-2.2c-3.5-4.2-4.9-9.7-4.2-15.1 c0.1-0.5,0.2-1,0.3-1.5c0.4-1.3,0.8-2.6,1.4-3.7c0.3-0.5,0.5-1.1,0.8-1.6l10.3-3.5h19.6l13.6,3.7l0.9,0.1v0.2l0.5,0.1l-0.2,1.7 L647.7,273.2z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M598.8,190.2c-4.2-0.5-8.8-0.2-12.1,2.6c-3.3,2.7-4.3,8.2-1.2,11.1c2.7,2.6,7,1.9,10.7,2.6 c6.5,1.5,11.1,7.2,11.3,13.9c-0.1,9.3-9,16.3-10.6,25.5c-1.1,6.2,1.6,12.8,6.1,17.3s10.8,6.8,17.2,7.4c6.4,0.6,12.7-0.4,18.8-1.9 c6.1-1.6,12.2-3.9,17.4-7.7c5.1-3.7,9.4-9,11.1-15.2s0.5-13.2-3.8-17.9c-4.9-5.4-13.1-7.3-17.3-13.2c-4.7-6.7-3-16.2-6.8-23.4 c-2.6-4.8-7.4-8.1-12.6-9.9c-5.2-1.7-10.7-2.1-16.2-2.3c-2.8-0.1-5.8-0.1-8.5,0.9c-2.6,1-5,3.5-5.1,6.3 C597,189.2,598.8,190.2,598.8,190.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationAlerts);
export default __webpack_public_path__ + "static/media/illustration_alerts.8b59c8c82228f5d44288971f9ea78ca1.svg";
export { ForwardRef as ReactComponent };